import { defineStore } from 'pinia'
import { useTokenStore } from '@/stores/token'

export const useRequestsStore = defineStore('requests', () => {

    const tokenStore = useTokenStore()
    const timegap = 20

    /**
     * Метод используется в системе авто-обновленияю токена
     */
    async function fetchRequestWoToken(payload) {

        let parameters = {
            method: payload.method,
            cache: 'no-cache',
            referrerPolicy: 'origin-when-cross-origin',
            headers: new Headers()
        }

        if(payload.data) {
            if(payload.type) {
                payload.type == 'json' ?
                    parameters.body = JSON.stringify(payload.data) :
                    parameters.body = payload.data
            } else {
                parameters.body = JSON.stringify(payload.data)
            }
        }

        try {

            const request   = await fetch(payload.address, parameters)
            const response  = await request.text()
            const result    = await JSON.parse( response )

            if(request.ok) {
                const extDate = Number(result?.accessExpires?.at || 0)
                if (
                    extDate &&
                    (extDate + timegap) * 1000 > Date.now() // @TODO: Защита от забегания вперёд времени клиента (время, установленное вручную)
                ) {
                    return result
                } else {
                    logout()
                    return { error: 'logout' }
                }
            }

            let msg = result?.details[0]?.value

            return { error: msg || 'EUnknown' }
        } catch {
            return { error: 'EConnection' }
        }
    }

    async function fetchRequest(payload) {

        try {

            /**
             * 1. Если рефреш токен не обновляется в данный момент
             *      иначе см. 1.1
             */
            if (tokenStore.refreshPromise === null) {

                let parameters = {
                    method: payload.method,
                    cache: 'no-cache',
                    referrerPolicy: 'origin-when-cross-origin',
                    headers: new Headers()
                }

                if(payload.headers) {
                    try {
                        let userHeadersArray = payload.headers.split(';')
                        userHeadersArray.map(header => {
                            let userHeader = header.split(':')
                            parameters.headers.append(userHeader[0], userHeader[1])
                        })
                    } catch(e) {

                        return { error: 'ERequestUserHeaders' }
                    }
                }

                if (payload.token) {

                    let accessExpired   = tokenStore.accessExpired,
                        refreshExpired  = tokenStore.refreshExpired

                    let accessDelta     = accessExpired - Date.now(),
                        refreshDelta    = refreshExpired - Date.now()

                    if (accessDelta < timegap) {

                        if(refreshDelta > timegap) {

                            tokenStore.refreshPromise = tokenStore.refreshToken()
                            return fetchRequest(payload)

                        } else {

                            logout()
                            return { error: 'logout' }
                        }
                    }

                    parameters.headers.append('Authorization', 'Bearer ' + tokenStore.access)
                }

                if(payload.data) {
                    if(payload.type) {
                        payload.type == 'json' ?
                            parameters.body = JSON.stringify(payload.data) :
                            parameters.body = payload.data
                    } else {
                        parameters.body = JSON.stringify(payload.data)
                    }
                }

                // 4. Выполняем запрос
                const request = await fetch(payload.address, parameters)

                if(!request.ok && !request.headers) {

                    return { error: 'EConnection' }
                }

                const requestType = request.headers.get("Content-Type")

                if(requestType == 'application/pdf') {

                    const context = await request.blob()
                    return context

                } else {

                    const response  = await request.text()
                    const result = response.length ? await JSON.parse(response) : { success: true }

                    if(request.ok) return result

                    let msg = result?.details[0]?.value

                    if (msg == 'ETokenError' || msg == 'ETokenExpired') {
                        logout()
                        return { error: 'logout' }
                    }

                    return { error: msg || 'EUnknown' }
                }
            }

            /**
             * 1.1. Если рефреш токен обновляется в данный момент
             *      сюда попадает dispatch('fetchRequest', payload) из п.3 
             *      и 2 + n вызовы fetchRequest
             */

            // ждем обновление рефреш токена
            await tokenStore.refreshPromise
            tokenStore.refreshPromise = null

            // вызываем dispatch('fetchRequest', payload)
            if(tokenStore.access) {
                return fetchRequest(payload)
            } else {
                logout()
                return { error: 'logout' }
            }

        } catch {

            return { error: 'EConnection' }
        }
    }

    function logout() {

        localStorage.clear()
        location.reload()
    }

    return {

        timegap, 
        fetchRequestWoToken, 
        fetchRequest, 
        logout
    }
})